/**
 * Escape text before it is interpolated into HTML.
 *
 * Needed wherever user-supplied text reaches a raw-HTML sink — `v-html`, or
 * vue-material's `md-content-html`. A script marker's label is typed by the
 * user, so `Delete <strong>${marker.label}</strong>?` renders whatever they
 * put in it: a label containing markup produces a malformed dialog, and one
 * containing a tag with an event handler executes.
 *
 * Low severity on its own — you have to label your own marker with a payload,
 * and only collaborators on that project ever see it — but it is the same
 * class as the `v-html` sink already tracked in the list-view work, and it
 * costs nothing to close.
 *
 * `src/lib/inviteEmail.js` carries its own private copy of this function. It
 * should adopt this one, but NOT in the same change: that file is in the batch
 * currently under test for Thursday's promotion, and this is not worth
 * disturbing it for.
 */
export function escapeHtml(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export default escapeHtml;


// WEBPACK FOOTER //
// ./src/lib/escapeHtml.js